import { _ as _object_spread } from "@swc/helpers/_/_object_spread";
import { useViewport } from "@faire/web--source/ui/hooks/useViewport";
import { useGetModalSizing } from "./useGetModalSizing";
export var useModalStyle = function(hasImage, height, width, contentStyle, noPortal, overlayStyle) {
    var isMobile = useViewport().isMobile;
    return {
        content: _object_spread({}, useGetModalSizing(hasImage, isMobile, height, width), contentStyle !== null && contentStyle !== void 0 ? contentStyle : {}),
        overlay: _object_spread({}, noPortal ? {
            position: "fixed",
            width: "100vw",
            height: "100vh",
            top: 0,
            left: 0
        } : {}, overlayStyle !== null && overlayStyle !== void 0 ? overlayStyle : {})
    };
};
